import { render, staticRenderFns } from "./SocialShareLinks.vue?vue&type=template&id=16ca15d9"
import script from "./SocialShareLinks.vue?vue&type=script&lang=ts"
export * from "./SocialShareLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports